module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 74300.301ecffd.png";